export const IMAGE_MODEL_STANDARD = 'gemini-3.1-flash-image' as const;
export const IMAGE_MODEL_LITE = 'gemini-3.1-flash-lite-image' as const;

export const IMAGE_MODEL_IDS = [
  IMAGE_MODEL_LITE,
  IMAGE_MODEL_STANDARD,
] as const;

export type ImageModelId = typeof IMAGE_MODEL_IDS[number];

export const IMAGE_MODEL_OPTIONS = [
  {
    id: IMAGE_MODEL_LITE,
    label: '省钱预览',
    description: '适合先看构图和氛围 · 约 $0.034 / 张',
  },
  {
    id: IMAGE_MODEL_STANDARD,
    label: '高质量生成',
    description: '适合保留为正式插图 · 约 $0.067 / 张',
  },
] as const;

export function isImageModelId(value: string): value is ImageModelId {
  return (IMAGE_MODEL_IDS as readonly string[]).includes(value);
}
